import React from 'react';

export type HistoryContextType = { routeMatch: boolean; currentRoute: string };
export const HistoryContext = React.createContext<HistoryContextType>({
    routeMatch: false,
    currentRoute: ''
});
